import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { IsignInData } from '../../models/auth/signIn.model';

interface IInitialState {
  isAuthenticated: boolean;
  authData?: IsignInData | null;
}
const initialState: IInitialState = {
  isAuthenticated: false,
  authData: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuthentication(state, action: PayloadAction<IInitialState>) {
      state.authData = action.payload.authData;
      state.isAuthenticated = action.payload.isAuthenticated;
    },
    reset: () => initialState,
  },
});

export const authActions = authSlice.actions;
export default authSlice.reducer;
